<template>
  <div>
    <search
      v-if="isSearch"
      :delUrl="delUrl"
      @searchData="searchData"
      @resetData="searchData"
      :parentsList="parentsList"
      type="marking"
    ></search>
    <refreshbtn @refesh="refesh" :isBetWeen="true">
      <!-- v-if="!userInfo.is_outer" -->
      <template slot="left_btn">
        <!-- <el-button size="small" type="success" @click="batchlaunch"
            >批量上线</el-button
          >
          <el-button size="small" type="success" @click="batchlaunchoff"
            >批量审核</el-button
          > -->
          <!-- v-has="deleteUrl" -->
        <el-button
          size="small"
          type="success"
          @click="deleteData"
          >一键删除</el-button
        >
        <!-- v-has="editUrl" -->
        <el-button
          size="small"
          type="success"
          @click="remoteVisual"
          >批量更新</el-button
        >
      </template>
      <template slot="search-btns">
        <el-button
          title="普通搜索"
          size="small"
          icon="el-icon-search"
          @click="isSearch = !isSearch"
        ></el-button>
      </template>
    </refreshbtn>
    <videoMarkingTable
      :headerList="headerList"
      :tableData="tableData"
      @editData="editData"
      :total="total"
      :pages="search.page"
      :pageSize="search.size"
      :delFIle="delUrl"
      :isLook="true"
      :axiosTile="axiosTile"
      :parentsList="parentsList"
      :editUrl="editUrl"
      :deleteUrl="deleteUrl"
      ref="table"
      @lookVideo="lookVideo"
      @editRichText="editRichText"
      :isSelect="true"
    />
    <videoMarkingDialog
      :data="editOpen"
      @clearData="clearData"
      @pushData="updateData"
      :parentsList="parentsList"
      :isLook="false"
      ref="dialog"
    ></videoMarkingDialog>
    <lookVideoDialog
      ref="lookDialog"
      :isLook="false"
      @handlerSave="refesh"
    ></lookVideoDialog>
    <RichEditor ref="richText" @handlerLoadList="handlerClose"></RichEditor>
    <!--批量标签话题编辑弹窗-->
    <batch-tags-popup
      ref="batchTagsPopup"
      type="movie"
      @handlerClose="handlerClose"
    ></batch-tags-popup>
    <add-remote-dialog ref="addRemoteDialog"></add-remote-dialog>
    <bind-actor-dialog ref="bindActorDialog"></bind-actor-dialog>
  </div>
</template>

<script>
import videoMarkingTable from "./components/videoMarkingTable";
import videoMarkingDialog from "./components/videoMarkingDialog";
import search from "./components/search";
import lookVideoDialog from "./components/lookVideoDialog";
import RichEditor from "@/components/rich-editor";
import BatchTagsPopup from "./components/batchTagsPopup";
import AddRemoteDialog from "./components/addRemoteDialog";
import BindActorDialog from "./components/bindActorDialog";
import API from "@/api";
import local from "@/utils/localStroage.js";

export default {
  name: "videoPage",
  components: {
    videoMarkingTable,
    videoMarkingDialog,
    search,
    lookVideoDialog,
    RichEditor,
    BatchTagsPopup,
    AddRemoteDialog,
    BindActorDialog,
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
        end_at: null
      },
      axiosTile: "",
      delUrl: "/api/media/batch/delete",
      editUrl: "/api/task/point/batch/update",
      editOpen: {},
      total: 0,
      headerList: [
        {
          key: "任务ID",
          value: "id",
          align: "center",
          width: "120",
        },
        {
          key: "视频ID",
          value: "video_id",
          align: "center",
        },
        {
          key: "视频标题",
          value: "title",
          minWidth: "350",
        },
        //   {
        //     key: "演员",
        //     value: "actor",
        //     align: "center",
        //   },
        //   {
        //     key: "原封面",
        //     value: "o_cover",
        //     type: "image",
        //     align: "center",
        //   },
        {
          key: "优先级",
          value: "urgent",
          align: "center",
          type: "dictionary",
          dictionary: [
            {
              key: 2,
              value: "高",
            },
            {
              key: 1,
              value: "中",
            },
            {
              key: 0,
              value: "低",
            },
          ],
        },
        {
          key: "对接人ID",
          value: "user_id",
          align: "center",
        },
        {
          key: "对接人名称",
          value: "nick_name",
          align: "center",
          minWidth: "100",
        },
        {
          key: "发布者",
          value: "publisher",
          align: "center",
        },
        {
          key: "编辑者",
          value: "edit_by",
          align: "center",
        },
        {
          key: "状态",
          value: "status",
          align: "center",
          type: "dictionary",
          dictionary: [
            {
              key: 0,
              value: "进行中",
            },
            {
              key: 1,
              value: "完成",
            },
          ],
        },
        //   {
        //     key: "正片预览",
        //     value: "is_preview",
        //     align: "center",
        //   },
        //   {
        //     key: "横版封面",
        //     value: "h_cover",
        //     type: "image",
        //     align: "center",
        //   },
        //   {
        //     key: "竖版封面",
        //     value: "v_cover",
        //     type: "image",
        //     align: "center",
        //   },
        {
          key: "创建时间",
          value: "create_time",
          type: "time",
          align: "center",
        },
        {
          key: "修改时间",
          value: "update_time",
          type: "time",
          align: "center",
        },
      ],
      tableData: [],
      parentsList: [],
      isSearch: false,
      isRefesh: true,
      userInfo: undefined,
      deleteUrl: "/api/task/point/batch/delete",
    };
  },
  created() {
    this.userInfo = local.get("userInfo");
    let listRule = "/api/task/point/list";
    let obj = JSON.parse(
      JSON.parse(JSON.stringify(localStorage.getItem("btnPower")))
    );
    if (obj[listRule]) {
      this.isRefesh = true;
    } else {
      this.isRefesh = false;
    }
    this.getVideoList();
  },
  methods: {
    // 批量上线
    async batchlaunch() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要上线的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      const { msg, code, data } = await API.onlineVideo({ ids: ids });
      if (!code) {
        this.$message.success(
          "成功上线" + data.success + "条数据，失败" + data.failure + "条"
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    // 批量设置标签
    async openSetTags() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量设置标签的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.batchTagsPopup.open(ids);
    },
    // 批量设置标签
    async batchSetTags() {
      console.log("设置标签");
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      // const { msg, code, data } = await API.onlineVideo({ ids: ids });
      // if (!code) {
      //   this.$message.success(
      //     "成功上线" + data.success + "条数据，失败" + data.failure + "条"
      //   );
      //   this.getVideoList(this.search.page);
      // } else {
      //   this.$message.error(msg);
      // }
    },
    // 批量下线
    async batchlaunchoff() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要弃用的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$prompt("请输入弃用理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.handlebatchlaunchoff(ids, value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 批量下线
    async handlebatchlaunchoff(ids, refuse_reason) {
      const { msg, code, data } = await API.offlineVideo({
        ids: ids,
        refuse_reason: refuse_reason,
      });
      if (!code) {
        this.$message.success(
          "成功弃用" + data.success + "条数据，失败" + data.failure + "条"
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    refesh() {
      this.isRefesh ? this.getVideoList() : "";
    },
    // 获取列表数据
    async getSetsList() {
      // 获取视频列表
      const { data, code } = await API.taskPointList(
        this.search,
        this.axiosTile
      );
      if (!code) {
        this.tableData = data.data;
        this.total = data.pagination.count;
        this.$refs.table.loading = false;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$refs.table.loading = false;
      }
    },
    clearData() {
      this.$refs.dialog.openDialog = false;
      this.editOpen = {};
    },
    async updateData(data) {
      const { code, msg } = await API.updateVideoDatav(data);
      if (!code) {
        this.$message.success("编辑视频成功");
        this.getVideoList(this.search.page);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      } else {
        this.$message.error(msg);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      }
    },
    editData(data) {
      this.editOpen = JSON.parse(JSON.stringify(data));
      this.$refs.dialog.openDialog = true;
      this.$refs.dialog.loadVideo(data.src_480, data);
      this.$refs.dialog.delUrl = this.delUrl;
      this.$refs.dialog.getTargetTree();
    },
    async deleteData() {
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      if(ids.length === 0){
        this.$message({
          type: "warning",
          message: "请选择要删除的数据",
        });
        return false;
      }
      this.$confirm("确定要一键删除吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let ids = [];
          // this.$refs.table.multipleSelection.forEach((item) => {
          //   ids.push(item.id);
          // });
          console.log(ids, "ids");
          // 用户确认后执行删除
          const { code, msg } = await API.taskPointBatchDelete({ ids: ids });
          if (!code) {
            this.$message.success("一键删除成功");
            this.getVideoList(this.search.page);
            this.$refs.dialog.loading = false;
          } else {
            this.$message.error(msg);
            this.$refs.dialog.loading = false;
          }
        })
        .catch(() => {
          // 用户取消删除
          this.$message.info("已取消删除操作");
        });
    },
    searchData(data) {
      this.search = { page: 1, size: 10 };
      if (this.isRefesh) {
        data
          ? (this.search = Object.assign(this.search, data))
          : (this.search = { page: 1, size: 10 });
        this.getVideoList();
      }
    },
    async getVideoList(page) {
      this.search.page = page || 1;
      this.isRefesh
        ? this.$nextTick(() => {
            this.$refs.table.loading = true;
          })
        : "";
      this.isRefesh ? this.getSetsList() : "";
    },
    lookVideo(data) {
      this.$refs.lookDialog.openlookDialog = true;
      this.$refs.lookDialog.loadVideo(data.src, data);
    },
    editRichText(data) {
      this.$refs.richText.open(data);
    },
    async changeSize(pageSize) {
      this.search.page = 1;
      this.search.size = pageSize;
      this.getSetsList();
    },
    handlerClose() {
      this.getSetsList();
    },
    remoteVisual() {
      console.log("远程视觉");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量更新的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, "edit", "remote_operation");
    },
    remoteOperation() {
      console.log("远程运营");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量添加远程运营的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, "添加远程运营", "remote_operation");
    },
    bindActor() {
      console.log("绑定演员");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量添加演员的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.bindActorDialog.open(ids);
    },
  },
};
</script>

<style scoped></style>
